import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';
import { getIcon } from '../../../utils';
import { Container, Flex, Nav } from '../../common';

const StyledContactLinks = styled.a`
  & span {
    color: ${({ $color }) => $color};
    transition: all 0.25s;
    &:hover {
      color: ${({ $colorHover }) => $colorHover};
      transition: all 0.25s;
    }
  }
`;

const StyledIcon = styled.span`
  svg {
    color: ${({ $color }) => $color};
    &:hover {
      color: ${({ $colorHover }) => $colorHover};
    }
  }
`;

const NavbarSecondary = ({ page, sanity }) => {
  // Destructure content from page and sanity for clarity
  const { gbp } = page;
  const { colors, navbars } = sanity;

  // Build the physical address from GBP details
  const physicalAddress = [
    gbp?.address,
    gbp?.city,
    gbp?.stateShort && `${gbp?.stateShort}`,
    gbp?.zip,
  ]
    .filter(Boolean)
    .join(', ');

  // Create an array of contact information objects
  const contact = [
    {
      id: 1,
      icon: 'Address',
      anchor: physicalAddress,
      url: gbp?.gbpUrl,
    },
    {
      id: 2,
      icon: 'Email',
      anchor: gbp?.email,
      url: `mailto:${gbp?.email}`,
    },
    {
      id: 3,
      icon: 'Phone',
      anchor: gbp?.phone,
      url: `tel:${gbp?.phone}`,
    },
  ];

  // Determine which icon color to use based on navbar setting
  const useDarkIcons = navbars?.useDarkIcons
    ? colors?.accent?.dark
    : colors?.accent?.light;

  return (
    <Nav
      idName="nav-secondary"
      padding="none"
      classes="hidden lg:block z-50 w-full"
      isGradient={navbars?.isGradientBg}
      bgColor={colors?.navbar?.secondaryBgColor || colors?.primary?.default}
      bgColorStart={colors?.primary?.darker}
      bgColorMid={colors?.primary?.dark}
      bgColorEnd={colors?.primary?.default}
    >
      <Container padding="none" classes="max-w-7xl">
        <Flex classes="flex-row justify-between">
          {/* Left side: Offer icon and label */}
          <Flex classes="flex-row justify-start my-auto">
            <Flex classes="gap-x-3">
              <div className="relative">
                <GatsbyImage
                  image={navbars?.navOfferIcon?.asset?.gatsbyImageData}
                  alt={navbars?.navOfferIcon?.alt}
                  className="w-6 object-cover h-auto !align-middle"
                />
              </div>
              <div className="relative">
                <span className="text-lg italic text-white">
                  {navbars?.navOfferLabel}
                </span>
              </div>
            </Flex>
          </Flex>
          {/* Right side: Contact info */}
          <Flex classes="flex-row justify-end items-center h-12 gap-12">
            {contact.map((info) => {
              const IconComponent = getIcon(info?.icon);
              return (
                <Flex key={info.id} classes="my-auto">
                  <StyledContactLinks
                    $color={colors?.neutral?.white}
                    $colorHover={colors?.accent?.lighter}
                    href={info.url}
                    target="_blank"
                    rel="noopener"
                  >
                    <Flex classes="gap-x-3 items-center">
                      <StyledIcon
                        $color={useDarkIcons}
                        $colorHover={colors?.accent?.default}
                        className="my-auto"
                      >
                        <IconComponent />
                      </StyledIcon>
                      <span className="text-lg">{info.anchor}</span>
                    </Flex>
                  </StyledContactLinks>
                </Flex>
              );
            })}
          </Flex>
        </Flex>
      </Container>
    </Nav>
  );
};

export { NavbarSecondary };
